import React, { Component } from 'react';
import { Route, Link, withRouter } from 'react-router-dom';

class Sidebar extends Component {

  handleClick(e) {
    e.preventDefault();
    e.target.parentElement.classList.toggle('open');
  }

  activeRoute(routeName) {
    return this.props.location.pathname.indexOf(routeName) > -1 ? 'nav-item nav-dropdown open' : 'nav-item nav-dropdown';
  }

  // secondLevelActive(routeName) {
  //   return this.props.location.pathname.indexOf(routeName) > -1 ? "nav nav-second-level collapse in" : "nav nav-second-level collapse";
  // }

  render() {
    return (

      <div className="sidebar">
        <nav className="sidebar-nav">
          <ul className="nav">
            <br />
            <br />
            <li className="nav-item">
              <Link to={'/cuenta'} className="nav-link">
                <i className="fa fa-address-card-o" aria-hidden="true"></i> Cuenta
              </Link>
              <Link to={'/usuarios'} className="nav-link">
                <i className="fa fa-users" aria-hidden="true"></i> Usuarios
              </Link>
              <Link to={'/Locales'} className="nav-link">
                <i className="fa fa-cart-plus" aria-hidden="true"></i> Locales
              </Link>
              <Link to={'/set-de-datos'} className="nav-link">
                <i className="fa fa-database" aria-hidden="true"></i> Set de datos
              </Link>
              <Link to={'/registros'} className="nav-link">
                <i className="fa fa-table" aria-hidden="true"></i> Registros
              </Link>
              <Link to={'/historial'} className="nav-link">
                <i className="fa fa-history" aria-hidden="true"></i> Historial
              </Link>
              <Link to={'/formularios'} className="nav-link">
                <i className="fa fa-file-text-o" aria-hidden="true"></i>Formularios
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    )
  }
}

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.js